<script setup lang="ts">
navigateTo('/', { replace: true })
</script>

<template>
  <div class="px-8 py-6 text-gray-400">
    {{ $t('404.description') }}
  </div>
</template>
